import { Formik, FormikConfig } from 'formik'
import React from 'react'
import { RadioButtons } from 'src/components/Forms/Checkboxes'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import { EnumEeocStatus } from 'src/gql/graphql'

export interface FilterValues {
  status: EnumEeocStatus
}

export interface FiltersProps {
  onSubmit: FormikConfig<FilterValues>['onSubmit']
  initialState?: FilterValues
  isOpen: boolean
  toggleOpen: () => void
  defaultFilters: FilterValues
}

const Filters: React.FC<FiltersProps> = (props) => {
  const { initialState, defaultFilters, isOpen, toggleOpen } = props
  const handleClose = toggleOpen
  const statuses = Object.keys(EnumEeocStatus).map((s) => {
    const value = EnumEeocStatus[s as keyof typeof EnumEeocStatus]
    return { name: 'status', label: s, id: value, value }
  })
  const initialValues: FilterValues = initialState ?? defaultFilters
  return (
    <>
      <Modal isOpen={isOpen} toggle={handleClose} scrollable backdrop='static'>
        <Formik
          initialValues={initialValues}
          onSubmit={props.onSubmit}
        >
          {(props) => {
            const filter = (): void => {
              toggleOpen()
              void props.submitForm()
            }
            const handleClear = (): void => {
              props.resetForm(defaultFilters)
              void props.setValues(defaultFilters)
            }
            return (
              <>
                <ModalHeader toggle={handleClose}>Position Filters</ModalHeader>
                <ModalBody>
                  <form onSubmit={props.handleSubmit}>
                    <RadioButtons options={statuses} label='Status' />
                  </form>
                </ModalBody>
                <ModalFooter>
                  <Button color='link' onClick={handleClear}><small>Clear All</small></Button>
                  <Button onClick={handleClose}>Cancel</Button>
                  <Button color='primary' onClick={filter}>
                    <FontAwesomeIcon icon={faFilter} /> Filter
                  </Button>
                </ModalFooter>
              </>
            )
          }}
        </Formik>
      </Modal>
    </>
  )
}

export default Filters
